<template>
  <div data-app class="md-layout">
    <md-tabs
      md-alignment="centered"
      :md-active-tab="activeTab"
      @md-changed="updateActiveTab"
    >
      <md-tab id="tab-basket" md-label="BA Workbasket" class="scroll-area">
        <AdministrateBAWorkbasket @showBaKnockout="showBaKnockout"/>
      </md-tab>
      <md-tab id="tab-ba-knockout" md-label="BA Knockout">
        <AdministrateBAKnockout :targetId="targetBaId" />
      </md-tab>
      <md-tab id="tab-ram-knockout" md-label="RAM Knockout">
        <AdministrateRAMKnockout :targetId="targetRamId" />
      </md-tab>
    </md-tabs>
  </div>
</template>
<script>

import AdministrateBAKnockout from "@/pages/AdministrateBAKnockout";
import AdministrateRAMKnockout from "@/pages/AdministrateRAMKnockout";
import AdministrateBAWorkbasket from "@/pages/AdministrateBAWorkbasket";


export default {
  name: 'AdministrateBATools',
  components: {
    AdministrateBAKnockout,
    AdministrateRAMKnockout,
    AdministrateBAWorkbasket,
  },
  data() {
    return {
      activeTab: null,
      targetBaId: null,
      targetRamId: null,
    };
  },
  methods: {
    showBaKnockout(application) {
      this.activeTab = "tab-ba-knockout";
      this.targetBaId = application["app_no"];
    },
    updateActiveTab(id) {
      this.activeTab = id;
    }
  },
}
</script>

<style lang="scss">
.scroll-area {
  overflow-y: scroll;
  height: calc(100vh - 72px);
  padding: 0px;
}
</style>
